import script from "./sso-login-partner.vue?vue&type=script&lang=ts&setup=true"
export * from "./sso-login-partner.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__